<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

                <div class="modal-header" style="justify-content: flex-end;">
                  <button type="button" class="close" @click="$emit('closeModal')">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <h2 class="title">New User</h2>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nama Penuh<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.display_name" placeholder="Ketik Nama Penuh">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Username<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="username" v-model="form.username" placeholder="Ketik Username">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Password<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="password" name="password" v-model="form.password" placeholder="Ketik Password">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Konfirmasi Password<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="password" name="retype password" v-model="retype_password" placeholder="Ketik Ulang Password">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">Role<span style="color: red;">*</span></label>
                          <MultiSelect
                            v-model="postForm.role_id"
                            :options="options.role.map(x => x.id)"
                            :custom-label="opt => options.role.find(x => x.id == opt).name"
                            placeholder="Pilih Role"
                          ></MultiSelect>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">Cat Brand<span style="color: red;">*</span></label>
                          <MultiSelect
                            :disabled="postForm.role_id && options.role.find(x => postForm.role_id == x.id).name  != 'Warna'"
                            v-model="form.cat_brand_id"
                            :options="options.brand.map(x => x.id)"
                            :custom-label="opt => options.brand.find(x => x.id == opt).brand_name"
                            placeholder="Pilih Cat Brand"
                          ></MultiSelect>
                        </div>
                      </div>
                    </div>
                  <div class="row row-space">
                    <div class="col-12">
                      <div class="input-group">
                        <label class="label">TTD User</label>
                        <VueSignaturePad width="100%" height="300px" class="border border-secondary" ref="signaturePad" />
					              <button class="btn btn-danger mt-2" @click="$refs.signaturePad.undoSignature();">Reset</button>
                      </div>
                    </div>
                  </div>
                  <!-- Button Starts -->
                  <div class="row" style="padding-top:40px">
                    <div class="col text-center">
                      <button type="button" class="btn btn-outline-danger" style="width: 75px;" @click="$emit('closeModal')">Cancel</button>
                      <button type="button" class="btn btn-primary ml-4" style="width: 75px;" @click="submitForm">Create</button>
                    </div>
                  </div>
                  <!-- Button Ends -->
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
</template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
    import env from '@/env'
  
    export default {
      data () {
        return{
          test : null,
          options : {
            role : [],
            brand : []
          },
          form : {
            display_name : '',
            username : '',
            password : '',
            ttdUser : '',
            cat_brand_id : ''
          },
          postForm : {
            role_id : '',
            
          },
          retype_password : ''
        }
      },
      components : {
        MultiSelect
      },
      mounted () {
        this.fetchRoleOptions();
        this.fetchBrandCat()
      },
      watch : {

      },
      methods : {
        fetchBrandCat () {
          this.$http.get('/api/v1/masterData/cat-brand')
          .then((resp) => {
            this.options.brand = resp.data.data
          })
          .catch((err) => {
            console.log(err)
          })
        },
        fetchRoleOptions () {
          this.$http.get('/api/v1/roles?pagination=false')
          .then((resp)=>{
            this.options.role = resp.data.data;
          })
          .catch((err)=>{console.log(err);})
        },
        validateForm(){
          var valid = true;
          var error = [];

          if(this.form.display_name == '' || this.form.display_name == null){//Full Name [Required]
            valid = false;
            error.push('Full Name wajib diisi');
          }

          if(this.form.username == '' || this.form.username == null){//Username [Required]
            valid = false;
            error.push('Username wajib diisi');
          }

          if(this.form.password == '' || this.form.password == null){//Password [Required]
            valid = false;
            error.push('Password wajib diisi');
          }

          if(this.retype_password == '' || this.retype_password == null){//Retype Password [Required]
            valid = false;
            error.push('Retype Password wajib diisi');
          } else {
            if(this.form.password !== this.retype_password){//Password and Retype Password Not The Same
              valid = false;
              error.push('Password and Konfirmasi Password tidak sama');
            }
          }

          if(this.postForm.role_id == '' || this.postForm.role_id == null){//Role [Required]
            valid = false;
            error.push('Role wajib diisi');
          }

          if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
          else return valid;
        },
        async submitPic(image) {
          try {
            let formData = new FormData()

            let data = await fetch(image).then(function(res){return res.arrayBuffer();}).then(function(buf){return new File([buf], 'ttdImage.png',{type:'image/png'});})
            formData.append('image' , data)

                    let response = await this.$http.post(env.urlStart + '/api/v1/workorder/steps/upload' , formData , {headers : {"Content-Type":'multipart/form-data'}})
            
            return response.data.data.filename
          }
          catch(err) {
            this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong When Uploading Image'])
            console.log(err)
            return 'Error'
          }
        },
        async submitForm(){
          let vm = this;

          let user_id;
          let { isEmpty , data } = this.$refs.signaturePad.saveSignature()
          if(!isEmpty) this.form.ttdUser = await this.submitPic(data);

          if(await vm.validateForm()){
            this.$http.post('/api/v1/users', this.form)
            .then((resp)=>{
              user_id = resp.data.data.id;
            })
            .then(()=>{
              this.$http.put(`/api/v1/users/${user_id}/roles`, this.postForm)
              .then((resp)=>{
                this.$store.dispatch('triggerAlert', [true, [`Pekerja ${vm.form.username} telah berhasil dibuat`]]);
                this.$emit('updateTable');
                this.$emit('closeModal');
              })
              .catch((err)=>{console.log(err)})
            })
            .catch((err)=>{
              console.log(err);
              this.$store.dispatch('triggerAlert', [false, [`${err.response.data.data}`]]);
            })
          }
        },
      }
    }
  </script>
  
  <style scoped>  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
     #TITLE made by Colorlib (https://colorlib.com)
     ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  </style>
  